
import Component from "vue-class-component";
import Vue from "vue";
import {Prop} from "vue-property-decorator";
import ConfirmModal from "@/features/shared/components/ConfirmModal.vue";
import CreateUUID from "@/guid";

@Component({
    components: {
        ConfirmModal
    }
})
export default class ButtonWithConfirm extends Vue {
    @Prop({required: true})
    modalTitle!: string;

    @Prop({required: true})
    modalActionButtonText!: string;

    @Prop({required: false, default: "primary"})
    modalButtonVariant!: string;
    
    modalId = CreateUUID();
}
